import * as React from "react";
const SvgFiRrTrashCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16.776 11.312c.38.4.363 1.033-.037 1.414l-3.552 3.373a2.97 2.97 0 0 1-2.088.846 3 3 0 0 1-2.101-.849l-1.612-1.465a1 1 0 0 1 1.346-1.48l1.638 1.489c.414.403 1.042.401 1.427.021l3.565-3.387a1 1 0 0 1 1.414.037zM23 5a1 1 0 0 1-1 1h-.886l-1.277 13.472A4.98 4.98 0 0 1 14.86 24H9.132a4.98 4.98 0 0 1-4.977-4.521L2.859 6h-.86a1 1 0 1 1 0-2H6.1a5.01 5.01 0 0 1 4.899-4h2a5.01 5.01 0 0 1 4.899 4h4.101A1 1 0 0 1 23 5M8.172 4h7.656A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.828 2m10.934 2H4.87l1.278 13.287A2.987 2.987 0 0 0 9.134 22h5.728a2.987 2.987 0 0 0 2.986-2.717z"
    />
  </svg>
);
export default SvgFiRrTrashCheck;
